import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import FormInput from '~/components/form/TextInput.vue';
import Checkbox from '~/components/form/Checkbox';
import { required, email } from 'vuelidate/lib/validators';
import { name, notCompany } from '~/plugins/validationRules.js';
export default {
  props: ["isPanel"],
  components: {
    FormInput: FormInput,
    Checkbox: Checkbox
  },
  data: function data() {
    return {
      email: '',
      givenName: '',
      familyName: '',
      accept: false,
      name: null,
      errorMessage: null
    };
  },
  validations: {
    accept: {
      ticked: function ticked(value) {
        return value;
      }
    },
    givenName: {
      required: required,
      notCompany: notCompany,
      name: name
    },
    familyName: {
      required: required,
      notCompany: notCompany,
      name: name
    },
    email: {
      required: required,
      email: email,
      emailExists: function emailExists(value) {
        var _this = this;
        if (!this.$v.email.required || !this.$v.email.email) return false;
        return new Promise(function (resolve, reject) {
          _this.$axios.get('/user/checkemail', {
            params: {
              email: value
            },
            progress: false
          }).then(function (res) {
            resolve(res.data.result);
          }).catch(function (error) {
            resolve(false);
          });
        });
      }
    }
  },
  computed: {
    noFBEmail: function noFBEmail() {
      return !!this.$route.query.nofbemail;
    },
    acceptError: function acceptError() {
      return this.getValidationError('accept', {
        ticked: 'validation.termsAgree'
      });
    },
    emailError: function emailError() {
      return this.getValidationError('email', {
        required: 'validation.required',
        email: 'validation.email',
        emailExists: 'validation.emailUsed'
      });
    },
    givenNameError: function givenNameError() {
      return this.getValidationError('givenName', {
        required: 'validation.required',
        notCompany: 'validation.notCompany',
        name: 'validation.name'
      });
    },
    familyNameError: function familyNameError() {
      return this.getValidationError('familyName', {
        required: 'validation.required',
        notCompany: 'validation.notCompany',
        name: 'validation.name'
      });
    },
    next: function next() {
      var path = this.isPanel ? this.$route.path : this.$route.query.next;
      var redirectMap = {
        '/': '/my/feed/',
        '/learning': '/learning/my/'
      };
      return redirectMap[path] || path;
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  methods: {
    getValidationError: function getValidationError(field, validations) {
      if (!this.$v[field].$dirty) return null;
      for (var _i = 0, _Object$entries = Object.entries(validations); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          validation = _Object$entries$_i[0],
          errorMessage = _Object$entries$_i[1];
        if (!this.$v[field][validation]) return this.$t(errorMessage);
      }
      return null;
    },
    submit: function submit(event) {
      var _this2 = this;
      event.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$axios.post('/tempUser/register', {
        _csfr: this.appStore.csrfToken,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        next: this.$route.path
      }).then(function () {
        _this2.$emit('done', _this2.email);
      }).catch(function (error) {
        var res = error.response ? error.response.data : null;
        var toast = {
          title: _this2.$t('confirmEmail.errorTitle'),
          text: _this2.$t('confirmEmail.errorText'),
          icon: 'icon-ic-dismiss'
        };
        if (res) toast.text = res;
        _this2.$toastStore.add(toast);
      });
    },
    fbSubmit: function fbSubmit(event) {
      this.$v.accept.$touch();
      if (this.$v.accept.$invalid) return event.preventDefault();
    }
  }
};